import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        stepNum:1
    },
    mutations: {
        changStepNum(state, value=1){
            if(state.stepNum < 3){
                state.stepNum += parseInt(value);
            }
        },
        changStepNumCut(state){
            if(state.stepNum > 0){
                state.stepNum -= 1;
            }
        },
        initialStepNum(state){
            state.stepNum = 1;
        }
    }
})

export default store;
